import { Else, If, Then } from 'react-if';
import { useTranslation } from 'next-i18next';
import { useIsomorphicViewportDevice } from '@zep/react';
import ShowDesktop from '../../components/common/ShowDesktop';
import Empty from '../../components/service/common/Empty';
import S from './AssetControl.module.scss';
export const SettlementPageView = () => {
  const {
    t
  } = useTranslation(['manage']);
  const {
    isMobile
  } = useIsomorphicViewportDevice();
  return <If condition={isMobile} data-sentry-element="If" data-sentry-component="SettlementPageView" data-sentry-source-file="settlement.tsx">
      <Then data-sentry-element="Then" data-sentry-source-file="settlement.tsx">
        <ShowDesktop data-sentry-element="ShowDesktop" data-sentry-source-file="settlement.tsx" />
      </Then>
      <Else data-sentry-element="Else" data-sentry-source-file="settlement.tsx">
        <div className={S.page_title}>{t('manage:manage_settlement')}</div>
        <Empty image={{
        url: '/images/light/trouble/avatar_apologizing.png',
        width: 186,
        height: 124
      }} emptyItem={t('manage:settlement.update.title')} description={t('manage:settlement.update.description')} useCustomMessage={true} data-sentry-element="Empty" data-sentry-source-file="settlement.tsx" />
      </Else>
    </If>;
};